import { useState, useCallback } from 'react';

export type Mode = 'browse' | 'add' | 'edit';

export function usePW220AMode() {
  const [mode, setMode] = useState<Mode>('browse');

  const isEditing = mode === 'add' || mode === 'edit';

  const setAdd = useCallback(() => setMode('add'), []);
  const setEdit = useCallback(() => setMode('edit'), []);
  const setBrowse = useCallback(() => setMode('browse'), []);

  return { mode, setMode, isEditing, setAdd, setEdit, setBrowse };
}
